import { configureStore } from '@reduxjs/toolkit'
import authReducer from './auth/authSlice'
import authMiddlewares from './auth/authMiddlewares'
import machineReducer from './machine/machineSlice'

const store = configureStore({
  reducer: {
    authReducer,
    machineReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(authMiddlewares),
})

export default store
